export default "__VITE_ASSET__DkZLDw0B__"